import Icon from 'veui/components/Icon'

Icon.register({
  'file-other': {
    paths: [
      {
        fill: '#959eb8',
        d: 'M27.68 9.81l-6.66-8a1.34 1.34 0 00-1.03-.48H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#c1cad3',
        d: 'M21.02 1.81a1.34 1.34 0 00-1.03-.48v7.34c0 1.1.9 2 2 2h6c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M17.26 25.07A1.26 1.26 0 1116 23.8c.7 0 1.26.57 1.26 1.27zM16 11.42a4.8 4.8 0 00-4.8 4.82v.07c.04.3.3.54.62.54h.78c.34 0 .62-.27.62-.61a2.78 2.78 0 115.56 0c0 .84-.34 1.29-1.5 2.15l-.16.12c-1.5 1.13-2.13 1.92-2.13 3.4v.14c0 .35.29.64.64.64h.74c.35 0 .64-.29.64-.64v-.15c0-.63.29-1 1.32-1.77l.17-.12c1.61-1.21 2.3-2.1 2.3-3.77a4.8 4.8 0 00-4.8-4.82z'
      }
    ],
    width: '32',
    height: '32'
  }
})
